export var LbPer1kg = 2.20462;
